import { ModalController } from 'shared/Modal/models'
import ModalWindowLayout from 'shared/ModalWindowLayout/ModalWindowLayout'
import { Button } from 'shared/Button'
import './AiConsentModal.scss'

type AiConsentModalProps = {
  controller: ModalController<boolean>
}

export function AiConsentModal({ controller }: Readonly<AiConsentModalProps>) {
  return (
    <ModalWindowLayout className="AiConsentModal">
      <ModalWindowLayout.Header onClose={() => controller.close(false)}>
        AI Trade Analysis Consent
      </ModalWindowLayout.Header>
      <ModalWindowLayout.Content>
        <p className="subtitle text-big-bold">Before continuing, please review and accept the following:</p>
        <hr />
        <ul>
          <li>
            We will send your trading-related data to a third-party AI language model (LLM) for
            analysis and processing. The external AI service will generate your performance
            analysis.
          </li>
          <li>
            The data we send may include trade entries, exits, timestamps, instruments/markets,
            position details, and performance metrics.
          </li>
          <li>
            This analysis feature is based on past performance and should not be treated as
            personalized trading or investment advice. Past performance is not necessarily
            indicative of future results.
          </li>
          <li>
            We retain and handle your data in accordance with our{' '}
            <a href="https://bookmap.com/privacy-policy/" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            . The external AI service will also process the submitted data to provide the analysis.
          </li>
          <li>
            By clicking Accept, you consent to this processing and acknowledge that AI-generated
            analysis may contain errors and should be reviewed before making decisions.
          </li>
        </ul>
        <hr />
      </ModalWindowLayout.Content>
      <ModalWindowLayout.Footer className="AiConsentModalFooter">
        <Button onClick={() => controller.close(false)}>Cancel</Button>
        <Button color="primary" onClick={() => controller.close(true)}>
          Accept & Continue
        </Button>
      </ModalWindowLayout.Footer>
    </ModalWindowLayout>
  )
}
